var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuoteLeft = function SvgQuoteLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8BFD0",
    d: "M3.75 21.25C3.75 15.034 8.844 10 15.134 10h.759c1.679 0 3.036 1.34 3.036 3s-1.357 3-3.036 3h-.76c-2.93 0-5.312 2.353-5.312 5.25V22h6.072c3.349 0 6.071 2.69 6.071 6v6c0 3.31-2.722 6-6.071 6H9.82c-3.348 0-6.071-2.69-6.071-6V21.25Zm24.286 0C28.036 15.034 33.13 10 39.42 10h.759c1.679 0 3.035 1.34 3.035 3s-1.356 3-3.035 3h-.76c-2.93 0-5.312 2.353-5.312 5.25V22h6.072c3.348 0 6.071 2.69 6.071 6v6c0 3.31-2.723 6-6.071 6h-6.072c-3.349 0-6.071-2.69-6.071-6V21.25Z"
  })));
};
export default SvgQuoteLeft;